import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import classes from './Dashboard.module.scss';
import { Alert, Button, Typography } from 'antd';
import Container from 'shared/ui/Container/Container';
import Plan from '../components/Plan';
import { EMI } from 'shared/model/types';
import {
  getEMIAccounts,
  getEMIAccountMeta
} from 'shared/config/store/reducers/accountsSlice';
import { RootState } from 'shared/config/store/store';
import { getCards } from 'shared/config/store/reducers/cardsSlice';
import { getUserMeta } from 'shared/config/store/reducers/userSlice';
import { VerificationStatus } from 'entities/user/model/types';
import NoPlans from '../components/NoPlans/NoPlans';
import TransactionsViewByEmi from 'widgets/transactions/ui/TransactionsViewByEmi';
import { VerificationWidget, VerificationBanner } from 'widgets/verification';
import { useGetAccountsQuery } from 'entities/account/api';

const Dashboard = () => {
  const { formatMessage: t } = useIntl();
  const user = useSelector(getUserMeta);
  const emiMeta = useSelector((state: RootState) => getEMIAccountMeta(state, EMI.Wallester));
  const wallesterAccountMap = useSelector((state: RootState) =>
    getEMIAccounts(state, EMI.Wallester)
  );

  const accounts = {
    [EMI.Wallester]: wallesterAccountMap
  };
  const cards = {
    [EMI.Wallester]: useSelector(getCards(EMI.Wallester))
  };

  const isVerified = [
      VerificationStatus.Verified,
      VerificationStatus.Completed,
    ].includes(emiMeta?.kyc_status);

  const hasWallesterEmi = Object.keys(user.emiStatuses).includes(EMI.Wallester);
  const wallesterAccountsQuery = useGetAccountsQuery(
    { emi: EMI.Wallester },
    { skip: !hasWallesterEmi },
  );

  const hasWallesterAccounts = Object.keys(wallesterAccountMap).length > 0;
  const accountsQuerySettled =
    wallesterAccountsQuery.isSuccess || wallesterAccountsQuery.isError;
  const showDashboardTransactions =
    isVerified ||
    (accountsQuerySettled && !wallesterAccountsQuery.isError && hasWallesterAccounts);

  return (
    <>
      <VerificationWidget emi={EMI.Wallester}>
        <Container className={classes.wrapper}>
          <div className={classes.container}>
            {!hasWallesterEmi ? (
              <NoPlans />
            ) : (
              <>
                <Typography.Title id='dashboard-title' className={classes.title} level={2}>
                  {t({ id: 'screens.dashboard.title' })}
                </Typography.Title>
                {wallesterAccountsQuery.isError && (
                  <Alert
                    type="error"
                    showIcon
                    message={t({ id: 'error.common' })}
                    action={
                      <Button size="small" onClick={() => void wallesterAccountsQuery.refetch()}>
                        {t({ id: 'buttons.retry' })}
                      </Button>
                    }
                    style={{ marginBottom: 16 }}
                  />
                )}
                <Plan
                  planName={'Wallester'}
                  emi={EMI.Wallester}
                  accounts={accounts[EMI.Wallester]}
                  status={user.emiStatuses[EMI.Wallester]}
                  cards={cards[EMI.Wallester]}
                />

                <VerificationBanner />

                {showDashboardTransactions && (
                  <div style={{ marginTop: 32 }}>
                    <TransactionsViewByEmi emi={EMI.Wallester} />
                  </div>
                )}
              </>
            )}
          </div>
        </Container>
      </VerificationWidget>
    </>
  );
};
export default Dashboard;
